import React, { FC } from 'react'

import { getSafeHtml } from '../../utils/sanitizeUtils'

import * as SC from './styled'

export type HighlightProps = {
  className?: string
  text: string
  color?: string
  backgroundColor?: string
  transparent?: boolean
  lineHeight?: string
  dangerouslySetInnerHTML?: boolean
}

const Highlight: FC<HighlightProps> = (props) => {
  const {
    className,
    text,
    color,
    backgroundColor,
    transparent = false,
    lineHeight,
    dangerouslySetInnerHTML = false,
  } = props

  return (
    <SC.Container className={className} lineHeight={lineHeight}>
      {dangerouslySetInnerHTML ? (
        <SC.Highlight
          color={color}
          backgroundColor={backgroundColor}
          transparent={transparent}
          dangerouslySetInnerHTML={getSafeHtml(text)}
        />
      ) : (
        <SC.Highlight
          color={color}
          backgroundColor={backgroundColor}
          transparent={transparent}
        >
          {text}
        </SC.Highlight>
      )}
    </SC.Container>
  )
}

export default Highlight
